"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPercentage = exports.formatCompactNumber = exports.formatCurrency = exports.formatCompositeData = exports.formatTypeBreakdown = exports.formatSegmentBreakdown = exports.formatTimeSeriesForRecharts = exports.formatBucketLabel = void 0;
var formatBucketLabel = function (raw) {
    if (!raw)
        return "";
    var weekMatch = raw.match(/^(\d{4})-W(\d{2})$/);
    if (weekMatch) {
        var monday = isoWeekStart(Number(weekMatch[1]), Number(weekMatch[2]));
        return monday.toLocaleDateString("en-US", { month: "short", day: "numeric" });
    }
    var monthMatch = raw.match(/^(\d{4})-(\d{2})$/);
    if (monthMatch) {
        var monthStart = new Date(Number(monthMatch[1]), Number(monthMatch[2]) - 1, 1);
        return monthStart.toLocaleDateString("en-US", { month: "short" });
    }
    var parsed = new Date(raw);
    if (isNaN(parsed.getTime()))
        return raw;
    return parsed.toLocaleDateString("en-US", { month: "short", day: "numeric" });
};
exports.formatBucketLabel = formatBucketLabel;
function isoWeekStart(year, week) {
    var jan4 = new Date(Date.UTC(year, 0, 4));
    var dow = jan4.getUTCDay() || 7;
    var week1Monday = new Date(jan4);
    week1Monday.setUTCDate(jan4.getUTCDate() - dow + 1);
    var target = new Date(week1Monday);
    target.setUTCDate(week1Monday.getUTCDate() + (week - 1) * 7);
    return target;
}
var formatTimeSeriesForRecharts = function (data, xKey) {
    if (xKey === void 0) { xKey = "date"; }
    return data.map(function (point) {
        var _a;
        return (__assign((_a = {}, _a[xKey] = (0, exports.formatBucketLabel)(point.date), _a.value = point.value, _a.count = point.count, _a), point));
    });
};
exports.formatTimeSeriesForRecharts = formatTimeSeriesForRecharts;
var formatSegmentBreakdown = function (data) {
    return data.map(function (item) { return ({
        name: item.segment_name,
        value: item.value,
        percentage: item.percentage,
    }); });
};
exports.formatSegmentBreakdown = formatSegmentBreakdown;
var formatTypeBreakdown = function (data) {
    return data.map(function (item) { return ({
        name: item.type,
        value: item.value,
        percentage: item.percentage,
    }); });
};
exports.formatTypeBreakdown = formatTypeBreakdown;
var formatCompositeData = function (timeSeries) {
    return timeSeries.map(function (point) { return ({
        date: (0, exports.formatBucketLabel)(point.date),
        value: point.value,
        count: point.count || 0,
    }); });
};
exports.formatCompositeData = formatCompositeData;
var formatCurrency = function (value, currency) {
    if (currency === void 0) { currency = "ZAR"; }
    var code = currency || "ZAR";
    if (value === undefined || value === null) {
        return new Intl.NumberFormat("en-ZA", {
            style: "currency",
            currency: code,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(0);
    }
    return new Intl.NumberFormat("en-ZA", {
        style: "currency",
        currency: code,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(value);
};
exports.formatCurrency = formatCurrency;
var formatCompactNumber = function (value) {
    if (value === undefined || value === null)
        return "0";
    if (value >= 1000000) {
        return "".concat((value / 1000000).toFixed(1).replace(/\.0$/, ""), "M");
    }
    if (value >= 1000) {
        return "".concat((value / 1000).toFixed(1).replace(/\.0$/, ""), "K");
    }
    return value.toString();
};
exports.formatCompactNumber = formatCompactNumber;
var formatPercentage = function (value) {
    if (value === undefined || value === null)
        return "0%";
    return "".concat(value.toFixed(1), "%");
};
exports.formatPercentage = formatPercentage;
